import projectsModel from '../../../models/projects';
import Store from '../../../store/main';
import customDayTemplatesModel from '../../../models/customDayTemplates';
import moment from '../../../libs/moment';

export default {
  prepareTaskResourcesForWorker(tasks) {
    return tasks.map(task => {
      const resources = task.resources.map(res => {
        const resourceData = Store.getters['resourcesModel/getResourceById'](res.resource_id);

        return {
          ...res,
          workingHours: resourceData?.workingHours,
          workingDays: resourceData?.workingDays,
        };
      });

      return {
        ...task,
        resources,
      };
    });
  },
  prepareProjectConfigs() {
    const projectConfigs = [];
    const ganttIds = Store.getters['tasksModel/getAllData'].map(o => o.id);

    ganttIds.forEach(ganttId => {
      const calendar = gantt.getCalendar(ganttId);
      let projectConfig = projectsModel.getProjectConfig(ganttId);
      const customDaysData = customDayTemplatesModel.serialize().find(data => +data.ganttId === +ganttId);

      if (!calendar) {
        return;
      }

      if (!projectsModel.getItem(ganttId)) {
        projectConfig = Store.getters['tasksModel/getItem'](ganttId).workloadData;
      }

      projectConfigs.push({
        calendar: {
          id: ganttId,
          worktime: {
            hours: calendar.getConfig().hours,
            days: _.values(calendar.getConfig().dates),
          },
        },
        ganttId,
        ganttConfig: {
          estimation_mode: projectConfig.estimation_mode,
          apply_resource_calendar: projectConfig.apply_resource_calendar,
        },
        customDays: customDaysData ? customDaysData.customDays : [],
        totalEstimate: Store.getters['tasksModel/getTotalEstimateDataForProject'](ganttId),
      });
    });

    return projectConfigs;
  },

  returnTaskByRange(task, range) {
    if (!range) {
      return task;
    }

    const startDate = moment(task.start_date);
    const endDate = moment(task.end_date);
    // const taskByRange = (startDate.isSameOrAfter(range.start) && endDate.isSameOrBefore(range.end))
    //     || (startDate.isBefore(range.end) && endDate.isSameOrAfter(range.start)
    //     && !(startDate.isBefore(range.start) && endDate.isAfter(range.end)));

    const taskByRange = !(endDate.isBefore(range.start) || startDate.isAfter(range.end));

    return taskByRange ? task : false;
  },

  calculateYAxisIntervals(leftAxisValues, rightAxisValues) {
    const maxLeftValue = leftAxisValues.reduce((max, value) => (+value > max ? +value : max), 0);
    const maxRightValue = rightAxisValues.reduce((max, value) => (+value > max ? +value : max), 0);

    const leftInterval = maxLeftValue / 6;
    const rightInterval = maxRightValue / 6;

    return {
      left: leftInterval,
      right: rightInterval,
    };
  },

  defaultRange() {
    return {
      this_month: {
        period: 'this_month',
        start: moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        end: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
      },
      last_6_months: {
        period: 'last_6_months',
        start: moment().subtract(6, 'months').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      },
    };
  },

  truncateTextToTwoLinesWithNewline(text, maxWidth, font = '14px Lato') {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    ctx.font = font;

    const words = text.split(' ');
    const firstLineWords = [];
    let currentLine = '';

    for (let i = 0; i < words.length; i++) {
      const testLine = currentLine ? `${currentLine} ${words[i]}` : words[i];
      const width = ctx.measureText(testLine).width;

      if (i === 0 && ctx.measureText(words[i]).width > maxWidth) {
        const chars = words[i].split('');
        let firstPart = '';
        let secondPart = '';

        for (let j = 0; j < chars.length; j++) {
          const testFirst = firstPart + chars[j];

          if (ctx.measureText(testFirst).width < maxWidth) {
            firstPart = testFirst;
          } else {
            secondPart = chars.slice(j).join('');
            break;
          }
        }

        const restWords = words.slice(1).join(' ');

        return `${firstPart}\n${secondPart} ${restWords}`.trim();
      }

      if (width < maxWidth) {
        currentLine = testLine;
        firstLineWords.push(words[i]);
      } else {
        break;
      }
    }

    const secondLineWords = words.slice(firstLineWords.length);

    return `${firstLineWords.join(' ')}\n${secondLineWords.join(' ')}`.trim();
  },
};
